import gql from 'graphql-tag'
export default gql`mutation createFamilyMutation($family: BaseFamily!) {
  createFamily(family: $family) {
    name
    id
  }
}`